import * as React from 'react'

import { TFPaymentMethod } from '~graphql/generated/clientGraphql'
import { createContext } from '~logic/lib/react'

type TSelectedMethod = Nullable<TFPaymentMethod>
type TSetMethod = ReactSetState<Nullable<TFPaymentMethod>>

const [
  SelectedMethodProvider, //
  useSelectedPaymentMethodCtx,
] = createContext<TSelectedMethod>(`LockedOrderPaymentMethod`)

const [
  UpdateProvider, //
  useSetPaymentMethodCtx,
] = createContext<TSetMethod>(`SetLockedOrderPaymentMethod`)

type TProps = RequiredChildren

/**
 * Contains 2 providers: One provides the *selected payment method* and the other its *setter*:
 * - to get the selected method use `useSelectedPaymentMethod`,
 * - to obtain the setter use `useSetPaymentMethod`.
 */
export const OrderLockedPaymentMethodProvider: React.FC<TProps> = ({ children }) => {
  const [selectedMethod, setSelectedMethod] = React.useState<Nullable<TFPaymentMethod>>(null)

  return (
    <UpdateProvider value={setSelectedMethod}>
      <SelectedMethodProvider value={selectedMethod}>{children}</SelectedMethodProvider>
    </UpdateProvider>
  )
}

export { useSelectedPaymentMethodCtx, useSetPaymentMethodCtx }
